import React, { createContext, useState } from 'react';

const CacheContextDomicile = createContext();

export const CacheDomicileProvider = ({ children }) => {
		const [cache, setCache] = useState(JSON.parse(sessionStorage.getItem("cacheDomicile")) || {});

	const setCacheCustom = () => {
		sessionStorage.setItem("cacheDomicile", JSON.stringify(cache))
	}

	const clearCacheDomicile = () => {
		setCache({})
	}

	return (
		<CacheContextDomicile.Provider value={{ cache, setCache, setCacheCustom, clearCacheDomicile }}>
			{children}
		</CacheContextDomicile.Provider>
	);
};

export default CacheContextDomicile;
